// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","main":"App_main__nhgh3","mainWithBanner":"App_mainWithBanner__8OOtX","booting":"App_booting__GWkIC","skipLink":"App_skipLink__OIU9U"};